/**
 * Format a Date object as YYYY-MM-DD in local timezone.
 * Avoids the timezone shift caused by toISOString() which converts to UTC.
 */
export function toLocalDateString(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/**
 * Parse a YYYY-MM-DD string as a local-timezone Date (noon to avoid DST edge cases).
 * Avoids the UTC interpretation that `new Date("2026-03-19")` produces.
 */
export function parseLocalDate(dateStr: string): Date {
  const [y, m, d] = dateStr.split('-').map(Number)
  return new Date(y, m - 1, d, 12, 0, 0)
}
